import { FormatIcu } from '@tolgee/format-icu'
import { DevTools, LanguageStorage, Tolgee } from '@tolgee/react'
import { CachedBackend } from './cachedBackend'
import { languages, type Language } from './generated/i18n-meta.ts'
import { getCoreNamespaces } from './namespaceConfig'
export { resolveLanguageFromAcceptLanguage, resolveLanguageFromCountry } from './resolveLanguage'

export const DEFAULT_LANGUAGE = 'fi' as Language

export type TolgeeConfig = {
  apiUrl?: string
  apiKey?: string
  cdnUrl: string
  cacheKey?: string
}

export function createTolgeeInstance(config: TolgeeConfig) {
  const { apiUrl, apiKey, cdnUrl, cacheKey } = config
  const isDev = apiUrl && apiKey

  let tolgee = Tolgee()
    .use(FormatIcu())
    .use(
      CachedBackend({
        prefix: cdnUrl,
        cacheKey,
      })
    )
    .use(LanguageStorage())

  if (isDev) {
    tolgee = tolgee.use(DevTools())
  }

  const coreNamespaces = getCoreNamespaces()

  return tolgee.init({
    defaultLanguage: DEFAULT_LANGUAGE,
    availableLanguages: [...languages],
    defaultNs: 'common',
    ns: coreNamespaces,
    ...(isDev
      ? {
          apiUrl,
          apiKey,
        }
      : {}),
  })
}
